module.exports = __webpack_public_path__ + "named-36e311f0689e20a77e6dfdae3eb4b485-apple-touch-icon-120x120.png";